import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import NeracaPanel from "../components/laporan/NeracaPanel";
import LabaRugiPanel from "../components/laporan/LabaRugiPanel";
import StokPanel from "../components/laporan/StokPanel";
import PenjualanPanel from "../components/laporan/PenjualanPanel";

export default function Laporan() {
  return (
    <div data-testid="laporan-page">
      <p className="text-[10px] uppercase tracking-[0.15em] font-bold text-muted-foreground">Pembukuan</p>
      <h1 className="mt-1 text-2xl font-bold tracking-tight" style={{ fontFamily: "'Work Sans', sans-serif" }}>Laporan Keuangan & Stok</h1>

      <Tabs defaultValue="neraca" className="mt-5">
        <TabsList className="grid w-full grid-cols-4" data-testid="laporan-tabs">
          <TabsTrigger value="neraca" data-testid="tab-neraca">Neraca</TabsTrigger>
          <TabsTrigger value="laba-rugi" data-testid="tab-laba-rugi">Laba Rugi</TabsTrigger>
          <TabsTrigger value="stok" data-testid="tab-stok">Stok</TabsTrigger>
          <TabsTrigger value="penjualan" data-testid="tab-penjualan">Penjualan</TabsTrigger>
        </TabsList>
        <TabsContent value="neraca"><NeracaPanel /></TabsContent>
        <TabsContent value="laba-rugi"><LabaRugiPanel /></TabsContent>
        <TabsContent value="stok"><StokPanel /></TabsContent>
        <TabsContent value="penjualan"><PenjualanPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
